import { PencilSimpleLine, Trash } from '@phosphor-icons/react'
import { Table } from 'antd'
import {
  useDeleteCommunitySchool,
  useGetCommunitySchool,
} from 'api/Settings/ManageCommunities'
import Spinner from 'components/Spinner'
import AlertModal from 'helper/AlertModal'
import React, { useEffect, useMemo, useState } from 'react'
import { CommunitySchoolStore } from 'state/setting/communitySchool'
import { CommunitySchoolType } from 'types/settings/communityschool'
import CommunitySchoolModal from '../Modals/CommunitySchoolModal'

interface CommunitiesTablesProps {
  id: string
}

const CommunitiesTables: React.FC<CommunitiesTablesProps> = ({ id }) => {
  const [alertModal, setAlertModal] = useState<boolean>(false)
  const {
    setAddCommunitySchoolModal,
    communitySchoolData,
    setCommunitySchoolData,
  } = CommunitySchoolStore(store => ({
    setAddCommunitySchoolModal: store.setAddCommunitySchoolModal,
    communitySchoolData: store.communitySchoolData,
    setCommunitySchoolData: store.setCommunitySchoolData,
  }))

  const { data, isLoading, isFetching, refetch } = useGetCommunitySchool()
  const { mutate: deleteCommunitySchoolMutation, isLoading: deleteLoading } =
    useDeleteCommunitySchool()

  const handleEditClick = (data: CommunitySchoolType) => {
    setCommunitySchoolData(data)
    setAddCommunitySchoolModal(true)
  }

  const handleDelete = (data: CommunitySchoolType) => {
    setCommunitySchoolData(data)
    setAlertModal(true)
  }

  const handleYesDelete = () => {
    deleteCommunitySchoolMutation(communitySchoolData._id, {
      onSuccess: () => {
        setCommunitySchoolData(undefined)
        setAlertModal(false)
      },
    })
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => <p className="text-14 w-400">{text}</p>,
    },
    {
      title: 'Website',
      dataIndex: 'website',
      key: 'website',
      render: (text: string) => <p className="text-14 w-400">{text}</p>,
    },

    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      render: (text: string) => (
        <img src={text} alt="icon" className="w-30px h-30px radius-rounded" />
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      width: '100px',
      render: (data: CommunitySchoolType) => (
        <div className="flex align-center gap-20px">
          <PencilSimpleLine
            size={20}
            color="#000"
            className="pointer"
            onClick={() => handleEditClick(data)}
          />
          <Trash
            size={20}
            color="#ff6961"
            className="pointer"
            onClick={() => handleDelete(data)}
          />
        </div>
      ),
    },
  ]

  const tableData = useMemo(() => {
    return data?.map((item: CommunitySchoolType) => ({
      key: item._id,
      name: item.name,
      website: item.button.link,
      icon: item.logo.thumb,
      updatedAt: item.updatedAt,
      actions: item,
    }))
  }, [data])

  useEffect(() => {
    refetch()
  }, [id])

  return (
    <>
      <div>
        {isLoading || isFetching ? (
          <div className="w-full h-70vh flex align-center justify-center">
            <Spinner />
          </div>
        ) : (
          <Table
            className="colored_header_table"
            columns={columns}
            dataSource={tableData}
            pagination={false}
          />
        )}
      </div>
      {alertModal && (
        <AlertModal
          isModalVisible={alertModal}
          setIsModalVisible={setAlertModal}
          data={{
            name: 'Community School',
            heading: 'Delete Community School',
            message1: 'Are you sure you want to delete this community school?',
            okText: 'Yes, delete',
          }}
          onYesClick={handleYesDelete}
          loading={deleteLoading}
        />
      )}
    </>
  )
}

export default CommunitiesTables
